import dynamic from 'next/dynamic';
import { LegalConsentProps } from './LegalConsent.types';
import { getPagePropFromWindow } from './../../utils';
import { FEATURE_FLAG_KEYS } from '../../constants';

const LegalConsentV2 = dynamic<LegalConsentProps>(() =>
  import('./LegalConsentV2').then(module => module.LegalConsentV2)
);

const LegalConsent = dynamic<LegalConsentProps>(() =>
  import('./LegalConsents').then(module => module.LegalConsent)
);

export const LegalConsentMGP = (props: LegalConsentProps) => {
  const useNewConsent = getPagePropFromWindow(FEATURE_FLAG_KEYS.ENABLE_NEW_LEGAL_CONSENT) && !props?.r0Checkout;
  return useNewConsent ? <LegalConsentV2 {...props} /> : <LegalConsent {...props} />;
};
